import { Component, OnInit } from '@angular/core';
import { AppTokenHandler } from 'src/app/Common/app-token-handler';
import { environment } from '../../../environments/environment';
import { UntypedFormControl } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';
@Component({
  selector: 'app-header-main',
  templateUrl: './header-main.component.html',
  styleUrls: ['./header-main.component.scss']
})
export class HeaderMainComponent implements OnInit {
  userDetails: any;
  public positionOptions: TooltipPosition[] = ['left']; // Tooltip postion
  // tslint:disable-next-line:typedef
  public position = new UntypedFormControl(this.positionOptions[0]);
  constructor(private appTokenHandler: AppTokenHandler) { }

  ngOnInit() {
    this.userDetails = this.appTokenHandler.getLoginUserInfo();
  }
  logoutUser() {
    if (!confirm('Are you sure you want to log out?')) {
      return;
    }
    window.location.href = environment.logoutUrl;
  }
}
